import { SenderLoginFormValues } from "./schema";

export type GetSenderLoginDefaultValuesArgs = {
  ssoToken?: string;
};

export function getSenderLoginDefaultValues({
  ssoToken,
}: GetSenderLoginDefaultValuesArgs = {}): SenderLoginFormValues {
  return {
    challenge: "",
    email: "",
    password: "",
    ssoToken,
  };
}
